export const JOB_TYPE_BACKFILL = 'backfill'
export const JOB_TYPE_EXTERNAL = 'external'
export const JOB_TYPE_INTERNAL = 'internal'

export const JOB_STATUS_ONLINE = 'online'
export const JOB_STATUS_INVISIBLE = 'unsichtbar'

export const JOB_TYPES = [
  JOB_TYPE_BACKFILL,
  JOB_TYPE_EXTERNAL,
  JOB_TYPE_INTERNAL
]

export const JOB_STATUSES = [JOB_STATUS_ONLINE, JOB_STATUS_INVISIBLE]

export const JOB_COMPANY_TAB = 'profile'
export const JOB_DETAIL_TAB = 'detail'
export const IFRAME_DEFAULT_HEIGHT = 5000
